<template>
  <div id="tab">
    <el-tabs type="border-card">
      <el-tab-pane label="销售形式">
        <el-card class="box-card-query" shadow="never">
          <el-form :inline="true" size="small">
            <el-form-item label="查询条件">
              <el-input placeholder="输入销售形式名称/简称查询" v-model="queryInfo.keyWords" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getTableData">查询</el-button>
            </el-form-item>
            <el-form-item style="float: right;">
              <el-button @click="dialogFormVisible = true">添加</el-button>
            </el-form-item>
          </el-form>
        </el-card>
        <div class="table" v-loading="tableLoading">
          <el-table ref="table" :data="tableData" border stripe height="100%" max-height="100%">
            <el-table-column type="index" width="55" align="center"></el-table-column>
            <el-table-column prop="saleTypeName" label="销售形式名称"></el-table-column>
            <el-table-column prop="shortName" label="简称"></el-table-column>
            <el-table-column prop="priceRatio" label="价格比">
              <template slot="header">
                <span>价格比</span>
                <span style="color: #F56C6C;">（商品价格=标准价*价格比）</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="{ row }">
                <div style="display: flex;">
                  <el-switch v-if="row.isUpdateEnabled == 'Y'" v-model="row.isEnabled" active-text="启用" inactive-text="禁用" active-value="Y" inactive-value="N" size="mini" style="margin-right: 12px;" @change="changeSwitch($event, row)"></el-switch>
                  <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                    <el-button v-if="row.saleType == 'Y'" size="mini" type="text" icon="iconfont icon-bianji" @click="editData(row)"></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除" placement="top">
                    <el-button v-if="row.saleType == 'Y'" size="mini" type="text" icon="el-icon-delete" @click="deleteData(row)"></el-button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[10, 20, 100]" :page-size="pagination.size" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
      </el-tab-pane>
    </el-tabs>
    <el-dialog width="500px" :title="isEdit ? '编辑销售形式' : '添加销售形式'" :visible.sync="dialogFormVisible" @close="dialogFromClose" :close-on-click-modal="false" destroy-on-close>
      <el-form ref="dialogFromRef" :model="dialogFrom" label-width="80px" :rules="dialogFromRules">
        <el-form-item label="销售形式" prop="saleTypeName">
          <el-input v-model="dialogFrom.saleTypeName"></el-input>
        </el-form-item>
        <el-form-item label="简称" prop="shortName">
          <el-input v-model="dialogFrom.shortName"></el-input>
        </el-form-item>
        <el-form-item label="价格比" prop="priceRatio">
          <el-input-number v-model="dialogFrom.priceRatio" :precision="2" :min="0"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      queryInfo: {
        keyWords: ''
      },
      tableLoading: false,
      tableData: [],
      pagination: {
        page: 1,
        size: 20,
        total: 0
      },
      dialogFormVisible: false,
      isEdit: false,
      dialogFrom: {
        id: '',
        saleTypeName: '',
        shortName: '',
        priceRatio: 0.00
      },
      dialogFromRules: {
        saleTypeName: [
          { required: true, message: '请输入销售形式', trigger: 'blur' },
          { min: 0, max: 50, message: '长度在 0 到 50 个字符', trigger: 'blur' },
          {
            type: 'string',
            required: true,
            pattern: /^[\u4e00-\u9fa5a-zA-Z\d\(\)（）\_\-\.\*]+$/,
            message: '请输入正确的销售形式',
            trigger: ['change', 'blur']
          }
        ],
        shortName: [
          { required: true, message: '请输入简称', trigger: 'blur' },
          { min: 0, max: 20, message: '长度在 0 到 20 个字符', trigger: 'blur' },
          {
            type: 'string',
            required: true,
            pattern: /^[\u4e00-\u9fa5a-zA-Z\d\(\)（）\_\-\.\*]+$/,
            message: '请输入正确的简称',
            trigger: ['change', 'blur']
          }
        ]
      }
    }
  },
  created () {
    this.getTableData()
  },
  mounted() {
    this.onresize()
    window.addEventListener("resize", () => this.onresize(), false)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onresize(), false)
  },
  methods: {
    async getTableData () {
      this.tableLoading = true
      const { data: res } = await this.$http.post('/Account/salSaleType/selectSalSaleList.html', this.Qs.stringify({
        keyWords: this.queryInfo.keyWords,
        page: this.pagination.page,
        size: this.pagination.size
      }))
      this.tableLoading = false
      if (res.code != 'success') return this.$message.error(res.message)
      let { total, data } = JSON.parse(res.result)
      this.pagination.total = total
      this.tableData = JSON.parse(data)
    },
    handleSizeChange (newSize) {
      this.pagination.size = newSize
      this.getTableData()
    },
    handleCurrentChange (newPage) {
      this.pagination.page = newPage
      this.getTableData()
    },
    onSubmit () {
      this.$refs['dialogFromRef'].validate(async (valid) => {
        if (valid) {
          const { data: res } = await this.$http.post(this.isEdit ? '/Account/salSaleType/updateSalSale.html' : '/Account/salSaleType/addSalSale.html', this.Qs.stringify(this.dialogFrom))
          if (res.code != 'success') return this.$message.error(res.message)
          this.$message.success(res.message)
          this.dialogFormVisible = false
          this.getTableData()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async editData (row) {
      if (row.saleType == 'N') {
        return false
      }
      this.dialogFrom = { ...row }
      this.isEdit = true
      this.dialogFormVisible = true
    },
    async deleteData ({ id, saleType }) {
      if (saleType == 'N') {
        return false
      }
      const confirmResult = await this.$confirm('此操作为删除操作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') return this.$message.info('取消删除')
      const loading = this.$loading({
        lock: true,
        text: '删除中，请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const { data: res } = await this.$http.post('/Account/salSaleType/deleteSalSale.html', this.Qs.stringify({ id }))
      loading.close()
      if (res.code != 'success') return this.$message.error(res.message)
      this.$message.success(res.message)
      this.getTableData()
    },
    async changeSwitch(isEnabled, { id }) {
      const { data: res } = await this.$http.post('/Account/salSaleType/updateSalSaleIsEnabled.html', this.Qs.stringify({ id, isEnabled }))
      if (res.code != 'success') return this.$message.error(res.message)
      this.$message.success(res.message)
      this.getTableData()
    },
    dialogFromClose () {
      this.dialogFrom = {
        id: '',
        saleTypeName: '',
        shortName: '',
        priceRatio: 0.00
      }
    },
    onresize() {
      this.$nextTick(() => {
        console.log(111111)
        this.$refs.table.doLayout()
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .el-tabs {
    height: 100%;
    display: flex;
    flex-flow: column;
    ::v-deep .el-tabs__item {
      height: 34px;
      line-height: 34px;
    }
    ::v-deep .el-tabs__content {
      flex: 1;
      padding-top: 0;
      box-sizing: border-box;
      .el-tab-pane {
        height: 100%;
        display: flex;
        flex-flow: column;
        .box-card-query {
          flex-shrink: 0;
          height: 58px;
          .el-card__body {
            padding: 12px;
            .el-form {
              .el-form-item {
                margin-bottom: 0;
              }
            }
          }
        }
        .table {
          flex: 1;
          height: calc(100% - 60px - 40px);
          .el-icon-delete {
            font-size: 16px;
          }
          .el-button--text {
            padding-top: 0;
            padding-bottom: 0;
          }
          .el-table {
            th, td {
              padding: 6px 0;
              .cell {
                font-size: 14px;
                padding: 0 auto;
              }
            }
          }
        }
        .el-pagination {
          margin-top: 8px;
          height: 32px;
        }
      }
    }
  }
</style>